import { appPublicConfig } from '@/configs/appPublicConfig';

export const POINT_CHARGE_BASE_PATH = '/pointcharge';

export const POINT_CHARGE_3DS_SUCCESS_MESSAGE =
  'POINT_CHARGE_3DS_SUCCESS_MESSAGE';
export const POINT_CHARGE_3DS_FAILURE_MESSAGE =
  'POINT_CHARGE_3DS_FAILURE_MESSAGE';

export const POINT_CHARGE_3DS_SUCCESS_URL = `${appPublicConfig.MYACCOUNT}${POINT_CHARGE_BASE_PATH}/3ds-redirect-callback-success`;
export const POINT_CHARGE_3DS_FAILURE_URL = `${appPublicConfig.MYACCOUNT}${POINT_CHARGE_BASE_PATH}/3ds-redirect-callback-failure`;
